import React from 'react'
import PageWrapper from '../PageWrapper/PageWrapper'
import EnrolButton from '../EnrolButton/EnrolButton'
import Icons from '../Icons/Icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import './ContactPage.css'

const ContactPage = () => {
  return (
    <PageWrapper title='Contact'>
      {/* Contact Information Section */}
      <div className='contact-info-section'>
        <div className='contact-info-card'>
          <a href='mailto:chelsea@ccchoreography.org' className='contact-info-item contact-info-link'>
            <FontAwesomeIcon icon={faEnvelope} className='contact-icon' />
            <div>
              <h3>Email</h3>
              <span className='contact-link-text'>chelsea@ccchoreography.org</span>
            </div>
          </a>

          <a href='tel:0403406529' className='contact-info-item contact-info-link'>
            <FontAwesomeIcon icon={faPhone} className='contact-icon' />
            <div>
              <h3>Phone</h3>
              <span className='contact-link-text'>0403 406 529</span>
            </div>
          </a>

          <div className='contact-info-item'>
            <FontAwesomeIcon icon={faMapMarkerAlt} className='contact-icon' />
            <div>
              <h3>Follow Us</h3>
              <div className='contact-social-icons'>
                <Icons facebook instagram instagramAdults />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Locations Section */}
      <div className='locations-section'>
        <h2 className='locations-title'>Our Locations</h2>
        <p className='locations-intro'>
          Visit our dance studios in Newcastle NSW — CC Choreography at Hamilton North and Tiny
          Tutus preschool dance at Lambton.
        </p>
        <div className='locations-grid'>
          <div className='location-card'>
            <h3 className='location-name'>Studio 1: CC Choreography</h3>
            <p className='location-address'>
              Unit 23/54 Clyde St<br />
              Hamilton North
            </p>
            <a 
              href='https://www.google.com/maps/place/23%2F54+Clyde+St,+Hamilton+North+NSW+2292/@-32.912182,151.7349957,17z/data=!3m1!4b1!4m5!3m4!1s0x6b7315a8623a528d:0xe400a8fc4bf35bee!8m2!3d-32.9121865!4d151.7371844' 
              target='_blank' 
              rel='noopener noreferrer'
              className='location-link'
            >
              View on Google Maps
            </a>
          </div>

          <div className='location-card'>
            <h3 className='location-name'>Studio 2: Tiny Tutus</h3>
            <p className='location-address'>
              27 Wyong Rd<br />
              Lambton
            </p>
            <a 
              href='https://www.google.com/maps/search/27+Wyong+Rd,+Lambton' 
              target='_blank' 
              rel='noopener noreferrer'
              className='location-link'
            >
              View on Google Maps
            </a>
          </div>
        </div>
      </div>

      <div className='contact-enrol-cta'>
        <h3>Ready to Join Our Dance Family?</h3>
        <EnrolButton />
      </div>
    </PageWrapper>
  )
}

export default ContactPage